export const USER_TYPES = {
  Vet: 'VET',
  PetParent: 'PET_PARENT',
};
